import { DockerImageClient } from '@frontend/version/api';
import { DockerImage } from '@frontend/version/types';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { useAppDispatch } from '../../redux/store';

export const DOCKER_IMAGE_UPDATE_FORM_ID = 'docker-image-update-form';

export const useDockerImageUpdate = () => {
    const { accountId, imageId } = useParams();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const [dockerImage, setDockerImage] = useState<DockerImage | null>(null);

    const fetchDockerImage = async () => {
        if (!imageId) return;
        const image = await DockerImageClient.fetchDockerImage(imageId);
        setDockerImage(image);
    };

    useEffect(() => {
        fetchDockerImage();
    }, [imageId]);

    const onCancel = () => {
        navigate(-1);
    };

    const onSubmitSuccess = (obj: DockerImage) => {
        navigate('/docker-images');
    };

    return {
        dockerImage,
        dispatch,
        onCancel,
        onSubmitSuccess
    };
};
